
<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
 
<div 
  *ngIf="isPaying" 
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
  role="dialog"
  aria-live="polite"
>
  <div class="bg-white rounded-2xl shadow-2xl p-10 max-w-md w-full mx-4 text-center animate-fade-in">
    <app-loader
      [progressMode]="'indeterminate'"
      [showMessage]="true"
      [message]="loaderMessage"
      class="block"
    ></app-loader>
  </div>
</div>

  <div class="sticky top-0 z-10 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
    <div class="px-6 py-5 flex items-center justify-between">
      <div class="flex items-center gap-4">
        <button (click)="location.back()" class="p-3 rounded-xl bg-gray-100 hover:bg-gray-200 transition">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        <div class="flex items-center gap-3">
          <h1 class="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 !mt-3">
            Bill #{{ bill?.billId }}
          </h1>
          <span class="px-4 py-2 rounded-full text-sm font-bold" [ngClass]="{
              'bg-green-100 text-green-800': bill?.billStatus === 'WAITING_FOR_PAYMENT' && !isBillExpired(),
              'bg-red-100 text-red-800': isBillExpired() || bill?.billStatus === 'EXPIRED',
              'bg-yellow-100 text-yellow-800': bill?.billStatus === 'CN_REQUESTED',
              'bg-gray-100 text-gray-800': bill?.billStatus === 'CANCELLED' || bill?.billStatus === 'PAID'
            }">
            {{ isBillExpired() ? "EXPIRED" : (bill?.billStatus | titlecase) }}
          </span>
          <span *ngIf="bill?.controlNumber && !isBillExpired()" class="text-sm text-gray-500">
            Expires: {{ bill.controlNumberExpiredDate | date : "short" }}
          </span>
          <p class="text-sm text-gray-500 !mt-2">
            Issued on: {{ bill?.billDate | date : "mediumDate" }}
          </p>
        </div>
      </div>

      <!-- ACTION BUTTONS -->
      <div class="flex items-center gap-4">
     
        <button
          *ngIf="bill && bill.controlNumber"
          (click)="printBill()"
          class="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition transform hover:scale-105 no-print">
          <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
          </svg>
          Print Bill
        </button>
     <!-- 
      
        <button
          *ngIf="!bill?.controlNumber && bill?.billStatus !== 'PAID' && bill?.billStatus == 'CANCELLED' && bill?.billStatus !== 'EXPIRED'"
          (click)="requestControlNumber()"
          class="px-6 py-3 bg-yellow-400 hover:bg-yellow-300 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition transform hover:scale-105">
          Request Control Number
        </button>

    
        <button
          *ngIf="bill?.controlNumber && !isBillExpired() && bill?.billStatus !== 'PAID' && bill?.billStatus !== 'CANCELLED'"
          (click)="extendBill()"
          class="px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition transform hover:scale-105">
          Extend Bill
        </button>

      
        <button
          *ngIf="bill?.controlNumber && bill?.canCancel === true"
          (click)="openCancelModal()"
          [disabled]="bill?.billStatus === 'CANCELLED' || bill?.billStatus === 'PAID'"
          class="px-6 py-3 bg-red-500 hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition transform hover:scale-105">
          Cancel Bill
        </button> -->

   
        <button
          *ngIf="bill?.controlNumber && bill?.billStatus === 'WAITING_FOR_PAYMENT' && !isBillExpired()"
          (click)="payNow()"
          [disabled]="isBillExpired() || bill?.billStatus !== 'WAITING_FOR_PAYMENT'"
          class="px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold rounded-xl shadow-xl hover:shadow-2xl transition transform hover:scale-105">
          <span *ngIf="!isBillExpired(); else expiredText">Pay Now</span>
          <ng-template #expiredText>Expired</ng-template>
        </button>
      </div>
    </div>
  </div>


  <div *ngIf="!loading && bill" class="w-full flex flex-wrap gap-x-16 gap-y-4 my-8">
    <div class="sticky w-full xl:w-[40%] flex flex-col gap-4">
      <div *ngIf="bill.remarks" class="bg-amber-50 border border-amber-300 rounded-md p-4 w-full">
        <p class="text-amber-800 font-semibold text-md !mb-0">Remarks:</p>
        <p class="text-amber-900 text-lg mt-2 !mb-0">{{ bill.remarks }}</p>
      </div>
      <div class="border border-gray-300 rounded-md bg-white p-8">
        <div class="text-xs font-medium text-gray-500 uppercase tracking-wider pb-2 w-full border-b mb-4">
          Payer information
        </div>
        <div class="flex flex-wrap">
          <div class="flex flex-col w-1/2">
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Name</div>
            <p class="text-lg font-bold text-gray-900 truncate">{{ bill.payer.fullName }}</p>
          </div>
          <div class="flex flex-col w-1/2">
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Phone</div>
            <p class="text-lg font-bold text-gray-900 truncate">{{ bill.payer.phone }}</p>
          </div>
          <div class="flex flex-col w-1/2">
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Email</div>
            <p class="text-lg font-bold text-gray-900 truncate">{{ bill.payer.email }}</p>
          </div>

          <div class="w-full flex flex-wrap bg-primary-100 border border-primary-100 bg-primary-100/10 p-4 rounded-md">
            <div class="text-xs font-medium text-gray-500 uppercase tracking-wider pb-2 w-full border-b my-4">
              Bill Summary
            </div>
            <div class="flex flex-col w-1/2">
              <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Total Amount</div>
              <p class="text-lg font-bold text-primary truncate">{{ bill.totalAmount | number : "1.0-0" }}</p>
            </div>
            <div class="flex flex-col w-1/2">
              <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Status</div>
              <p [class]="findStatusClass(bill.billStatus)" class="text-md font-bold text-gray-900 truncate rounded-md px-4 py-[2px] w-fit">
                {{ bill.billStatus | replace : "_" : "" | titlecase }}
              </p>
            </div>
            <div class="flex flex-col w-1/2">
              <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Control Number</div>
              <p class="text-lg font-bold text-gray-900 truncate">{{ bill?.controlNumber || "Not Issued" }}</p>
            </div>
            <div class="flex flex-col w-1/2">
              <div class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Payment Type</div>
<p class="text-lg font-normal text-gray-900 truncate">
  {{ (bill?.paymentType || "") .split('_').join(' ')  }}
</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1">
      <div class="bg-white rounded-lg overflow-hidden border border-gray-200">
        <div class="bg-gradient-to-r from-primary to-primary-500 text-white p-4">
          <h3 class="!text-sm !font-bold uppercase !my-0">Bill Items</h3>
        </div>
        <div class="p-8">
          <table class="w-full">
            <thead class="border-b-2 border-gray-200">
              <tr>
                <th class="text-left py-1 px-6 font-bold text-gray-700">Product</th>
                <th class="text-center py-1 px-6 font-bold text-gray-700">Qty</th>
                <th class="text-right py-1 px-6 font-bold text-gray-700">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of bill.billItems" class="border-b hover:bg-gray-50">
                <td class="py-6 px-6 font-medium text-gray-900">{{ item.productName }}</td>
                <td class="text-center py-6 px-6 text-gray-700">{{ item.quantity }}</td>
                <td class="text-right py-6 px-6 font-bold text-gray-900">TZS {{ item.totalAmount | number : "1.0-0" }}</td>
              </tr>
            </tbody>
            <tfoot class="bg-primary-100/50 !rounded-md !overflow-hidden">
              <tr>
                <td colspan="2" class="text-right py-2 px-2 !text-2xl font-black text-gray-800">Total:</td>
                <td class="text-right py-2 px-2 !text-xl font-black text-indigo-700">TZS {{ bill.totalAmount | number : "1.0-0" }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !bill" class="text-center py-32">
    <p class="text-6xl font-bold text-gray-300">Bill Not Found</p>
  </div>
</div>

